import { MenuItem } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
// import { CircleIcon, SquareIcon, VercelLogoIcon } from '@radix-ui/react-icons';
import { CircleIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  breakpoints,
  DMRadioItem,
  preventEvent,
  SizeStyle,
  StyledGroup,
  TDSnapshot,
  useTldrawApp,
} from 'sn-wb-tldraw';
import { Utils } from 'sn-wb-tldraw-core';

import { strokeSize } from './SizeSelector';

const statusSelector = (s: TDSnapshot) => s.appState.status;

const currentStyleSelector = (s: TDSnapshot) => s.appState.currentDrawStyle;

export const SizeMenu = React.memo(function SizeMenu() {
  const app = useTldrawApp();

  const currentStyle = app.useStore(currentStyleSelector);
  const [displayedStyle, setDisplayedStyle] = React.useState(currentStyle);

  const handleSizeChange = React.useCallback((value: string) => {
    app.style({ size: value as SizeStyle });
  }, []);

  return (
    <>
      <StyledGroup dir="ltr" className="flex justify-center" value={displayedStyle.size}>
        <div className="flex flex-col gap-1  justify-center items-center mt-4 mb-8 smallScreen:mt-2 smallScreen:mb-4">
          {Object.keys(strokeSize).map((sizeStyle) => (
            <div key={sizeStyle} className="flex justify-center items-center">
              <MenuItem>
                <div className="w-46 h-24 smallScreen:w-30 smallScreen:h-20 flex justify-center rounded-sm items-center cursor-pointer hover:bg-gray-100">
                  <div
                    onClick={handleSizeChange.bind(null, sizeStyle)}
                    className={` ${
                      sizeStyle === displayedStyle.size ? 'bg-blue-500' : 'bg-gray-500'
                    } ${
                      sizeStyle === 'small'
                        ? 'w-9 h-9 smallScreen:w-6 smallScreen:h-6'
                        : sizeStyle === 'medium'
                        ? 'w-12 h-12 smallScreen:w-8 smallScreen:h-8'
                        : 'w-15 h-15 smallScreen:w-10 smallScreen:h-10'
                    } rounded-full`}
                  />
                </div>
              </MenuItem>
            </div>
          ))}
        </div>
      </StyledGroup>
    </>
  );
});
